
import React, { useState } from 'react';
import { Send, Loader2 } from 'lucide-react';

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  useTelegram: boolean;
  isLoading?: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSendMessage, useTelegram, isLoading = false }) => {
  const [message, setMessage] = useState('');

  const handleSendMessage = () => {
    if (!message.trim() || isLoading) return;
    
    onSendMessage(message);
    setMessage('');
  };
  
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <div className="border-t p-3">
      {useTelegram && (
        <div className="mb-2 text-xs px-2 py-1 bg-blue-50 text-blue-600 rounded">
          Mode Telegram activé
        </div>
      )}
      <div className="flex items-center">
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Écrivez votre message..."
          className="flex-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring-1 focus:ring-primary resize-none"
          rows={1}
          disabled={isLoading}
        />
        <button
          onClick={handleSendMessage}
          className="ml-2 p-2 bg-primary text-white rounded-full hover:bg-primary/90 transition-colors disabled:bg-gray-300"
          disabled={!message.trim() || isLoading}
          aria-label="Send message"
        >
          {isLoading ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />}
        </button>
      </div>
    </div>
  );
};

export default ChatInput;
